module.exports = __webpack_public_path__ + "img/overhead_lunge_2.25beefee.png";